import { render, staticRenderFns } from "./SendContract.vue?vue&type=template&id=e621a232&scoped=true"
import script from "./SendContract.vue?vue&type=script&lang=js"
export * from "./SendContract.vue?vue&type=script&lang=js"
import style0 from "./SendContract.vue?vue&type=style&index=0&id=e621a232&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e621a232",
  null
  
)

export default component.exports